import React from 'react';
import { PaisMercadoGlobalEnum } from '../../../../../common/types/enums/pais-mercado-global.enum';
import { PaymentOption } from '../../../../atoms/v2/payment-option/payment-option.atom';
import { MetodoPagamentoVendaEnum } from '../../../../../common/types/enums/metodo-pagamento.enum';
import { IconWrapper } from '../../../../atoms/v2/icon-wrapper/icon-wrapper.atom';
import { FaBarcode, FaPix } from 'react-icons/fa6';
import { Checkout } from '../../../../../common/types/checkout';
import { useTranslation } from 'react-i18next';
import * as S from './payment-methods-classic.style';
import { FaRegCreditCard, FaApple, FaAmazonPay } from 'react-icons/fa';
import { SiGooglepay } from 'react-icons/si';

type Props = {
  checkout: Checkout;
  selectedMethod: MetodoPagamentoVendaEnum;
  setSelectedMethod: (pm: MetodoPagamentoVendaEnum) => void;
  applePay?: {
    available: boolean;
    onClick: () => void;
    loading: boolean;
  };
  googlePay?: {
    available: boolean;
    onClick: () => void;
    loading: boolean;
  };
};

export const PaymentMethodsClassic: React.FC<Props> = ({
  checkout,
  setSelectedMethod,
  selectedMethod,
  applePay,
  googlePay,
}) => {
  const { t } = useTranslation();
  return (
    <S.PaymentOptions>
      {/* PIX */}
      {checkout?.paisEnum === PaisMercadoGlobalEnum.BRA &&
        checkout?.metodosPagamento?.includes('pix') && (
          <PaymentOption
            color={
              checkout?.checkoutConfig?.config?.checkoutData?.paymentMethods
                ?.color
            }
            active={selectedMethod === MetodoPagamentoVendaEnum.PIX}
            onClick={() => setSelectedMethod(MetodoPagamentoVendaEnum.PIX)}
          >
            <IconWrapper size="32px">
              <FaPix size={25} />
            </IconWrapper>
            <span>{t('paymentMethodDescription.PIX')}</span>
          </PaymentOption>
        )}

      {/* CARTÃO */}
      {checkout?.metodosPagamento?.includes('cc') && (
        <PaymentOption
          color={
            checkout?.checkoutConfig?.config?.checkoutData?.paymentMethods
              ?.color
          }
          active={selectedMethod === MetodoPagamentoVendaEnum.CARTAO_CREDITO}
          onClick={() =>
            setSelectedMethod(MetodoPagamentoVendaEnum.CARTAO_CREDITO)
          }
        >
          <IconWrapper size="32px">
            <FaRegCreditCard />
          </IconWrapper>
          <span>{t('paymentMethodDescription.CARTAO_CREDITO')}</span>
        </PaymentOption>
      )}

      {/* BOLETO */}
      {checkout?.paisEnum === PaisMercadoGlobalEnum.BRA &&
        checkout?.metodosPagamento?.includes('boleto') && (
          <PaymentOption
            color={
              checkout?.checkoutConfig?.config?.checkoutData?.paymentMethods
                ?.color
            }
            active={selectedMethod === MetodoPagamentoVendaEnum.BOLETO}
            onClick={() => setSelectedMethod(MetodoPagamentoVendaEnum.BOLETO)}
          >
            <IconWrapper size="32px">
              <FaBarcode size={25} />
            </IconWrapper>
            <span>{t('paymentMethodDescription.BOLETO')}</span>
          </PaymentOption>
        )}

      {/* Google Pay */}
      {checkout?.metodosPagamento?.includes('googlepay') &&
        googlePay?.available && (
        <PaymentOption
          color={
            checkout?.checkoutConfig?.config?.checkoutData?.paymentMethods
              ?.color
          }
          active={selectedMethod === MetodoPagamentoVendaEnum.GOOGLE_PAY}
          onClick={() =>
            setSelectedMethod(MetodoPagamentoVendaEnum.GOOGLE_PAY)
          }
        >
          <IconWrapper size="32px">
            <SiGooglepay size={25} />
          </IconWrapper>
          <span>Google Pay</span>
        </PaymentOption>
      )}

      {/* Apple Pay */}
      {checkout?.metodosPagamento?.includes('applepay') &&
        applePay?.available && (
          <PaymentOption
            color={
              checkout?.checkoutConfig?.config?.checkoutData?.paymentMethods
                ?.color
            }
            active={selectedMethod === MetodoPagamentoVendaEnum.APPLE_PAY}
            onClick={() =>
              setSelectedMethod(MetodoPagamentoVendaEnum.APPLE_PAY)
            }
          >
            <IconWrapper size="32px">
              <FaApple size={25} />
            </IconWrapper>
            <span>Apple Pay</span>
          </PaymentOption>
        )}

      {/* Amazon Pay removido — disponível apenas no checkout expresso */}
      {/* Amazon Pay */}
      {checkout?.metodosPagamento?.includes('amazonpay') && (
        <PaymentOption
          color={
            checkout?.checkoutConfig?.config?.checkoutData?.paymentMethods
              ?.color
          }
          active={selectedMethod === MetodoPagamentoVendaEnum.AMAZON_PAY}
          onClick={() =>
            setSelectedMethod(MetodoPagamentoVendaEnum.AMAZON_PAY)
          }
        >
          <IconWrapper size="32px">
            <FaAmazonPay size={25} />
          </IconWrapper>
          <span>Amazon Pay</span>
        </PaymentOption>
      )}
    </S.PaymentOptions>
  );
};
